import "./AppLoading.scss";

export default function AppLoading() {
  return (
    <div className="AppLoading lds-circle">
      <div>&nbsp;</div>
    </div>
  );
}
